import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";

export default class AGGridBigTextColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = this.cellRenderer();
    colDef.wrapText = true;
    colDef.autoHeight = true;
    return colDef;
  }

  private cellRenderer(): any {
    return (params: ICellRendererParams) => {
      if (!params.value)
        return params.value;
      if (params.value.includes("<"))
        return `<div class="tempo-tooltip-content">${params.value}</div>`;
      return `<div class="tw-whitespace-pre-wrap">${params.value}</div>`
    }
  }
}
